/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.create.controllers', [
  'acme.common.factory.notice'
])

.controller('CouponsCreateController', ['$scope', '$state', '$timeout', 'NoticeFactory', function($scope, $state, $timeout, NoticeFactory) {

    var transtionTimer,
      navigateTimer;

    $scope.couponsCreate = {

      model: {
        id: ''
      },

      notice: new NoticeFactory(),

      init: function() {
        title = {
          title: 'Edit Coupon',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.coupons.list');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            permissions: ['COUPONS_CREATE'],
            action: function() {
              $scope.couponsCreate.update(true);
            }
          }
        };

        $scope.$emit('Application::contentTitleChange', title);

        this.model.id = $state.params.couponId;

        $scope.$on('$destroy', this.onDestroy);

        $scope.$on('CouponsCreateController::reset', this.onReset);
        $scope.$on('CouponsCreateController::error', this.onError);
        $scope.$on('CouponsCreateController::success', this.onSuccess);
        $scope.$on('CouponsCreateController::transition', this.onTransition);
      },

      isActiveState: function(state) {
        var r = false,
          regex = new RegExp(state + "$");

        if ($state.current.name.match(regex)) {
          r = true;
        }

        return r;
      },

      save: function(next) {
        $scope.$broadcast('CouponsCreateController::save', { state: next });
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onReset: function(e, data) {
        $scope.couponsCreate.notice.hideErrorMessages();
        $scope.couponsCreate.notice.hideSuccessMessages();
      },
      onError: function(e, data) {
        $scope.couponsCreate.notice.hideSuccessMessages();
        $scope.couponsCreate.notice.showErrorMessages([{
          message: data.message
        }]);
      },
      onSuccess: function(e, data) {
        $scope.couponsCreate.notice.hideErrorMessages();
        $scope.couponsCreate.notice.showSuccessMessages([{
          message: data.message
        }]);
      },

      onTransition: function(e, data) {
        if (transtionTimer) {
          $timeout.cancel(transtionTimer);
        }
        if (navigateTimer) {
          $timeout.cancel(navigateTimer);
        }
        transtionTimer = $timeout(function() {
          $scope.couponsCreate.onReset();
          navigateTimer = $timeout(function() {
            $state.go(data.state);
          }, 300);
        }, 3000);
      }

    };

    $scope.couponsCreate.init();

}]);